import React from "react";

interface Props {
  as?: keyof JSX.IntrinsicElements;
  name: string;
}

const ProductName: React.FC<Props> = ({ as = "h1", name }) =>
  React.createElement(as, {
    className:
      "w-full m-0 font-serif text-xl !leading-[1.625] font-thin text-blue900 lg:text-xl",
    dangerouslySetInnerHTML: { __html: name },
  });

export default ProductName;
